import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule, forwardRef } from '@angular/core';

import { CommonModule } from '@angular/common';
import { ActionsButtonsComponent } from '../system-utils/actions-buttons/actions-buttons.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SidePanelComponent } from '../system-utils/side-panel/side-panel.component';
import { CustomLoadingOverlay, QueryExecutorComponent, QueryExecutorPopupDialog } from '../forms/query-executor/query-executor.component';
import DragDirective from '../system-utils/utils/directives/draggable-directive';
import { AngularSplitModule } from 'angular-split';
import { ArrayFilter } from '../system-utils/pipes/filter';
import { FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { ModuleRegistry } from '@ag-grid-community/core';
import { CsvExportModule } from "@ag-grid-community/csv-export";
import { AgGridModule } from "@ag-grid-community/angular"
import {ClientSideRowModelModule} from "@ag-grid-community/client-side-row-model";
import { GenericIconComponent } from '../system-utils/generic-icon/generic-icon.component';
import { IconServices } from '../services/icon.services';
import { ExpansePanelComponent } from '../system-utils/expanse-panel/expanse-panel.component';
import { FormArrayComponentComponent } from '../system-utils/form-array-component/form-array-component.component';
import { SuspendedMenuComponent } from '../system-utils/suspended-menu/suspended-menu.component';
import { SearchFieldService } from '../services/search-filed.service';
import {TranslateModule, TranslateLoader, TranslateService, TranslateStore, TranslatePipe} from '@ngx-translate/core';


import { CdkStepperModule } from '@angular/cdk/stepper';
import { SidePanelStepComponent, SidePanelStepperComponent } from "../system-utils/side-panel-stepper/side-panel-stepper.component";
import { TreeviewModule } from '@soy-andrey-semyonov/ngx-treeview';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { QueryExecutorComponentSettings } from '../forms/query-executor/query-executor-settings/query-executor-settings.component';
import { FormItemComponentComponent } from '../system-utils/form-item-component/form-item-component.component';
import { FormViewDirective } from '../dynamic-forms/form-view/form-view.directive';
import { UpperDirective } from '../system-utils/utils/directives/uppercase-directive';
import { CustomMaskDirective } from '../system-utils/utils/directives/custom-mask-directive';
import { TooltipDirective } from '../system-utils/utils/directives/tooltip-directive';
import { NumericDirective } from '../system-utils/utils/directives/numeric.directive';
import { FormViewInputComponent } from '../dynamic-forms/form-view/form-view-input/form-view-input.component';
import { DynamicFormsComponent } from '../dynamic-forms/dynamic-forms.component';
import { FormViewDateComponent } from '../dynamic-forms/form-view/form-view-date/form-view-date.component';
import { FormViewImageComponent } from '../dynamic-forms/form-view/form-view-image/form-view-image.component';
import { FormViewNumberComponent } from '../dynamic-forms/form-view/form-view-number/form-view-number.component';
import { FormViewRichTextComponent } from '../dynamic-forms/form-view/form-view-rich-text/form-view-rich-text.component';
import { FormViewSearchComponent } from '../dynamic-forms/form-view/form-view-search/form-view-search.component';
import { FormViewSelectComponent } from '../dynamic-forms/form-view/form-view-select/form-view-select.component';
import { FormViewTextComponent } from '../dynamic-forms/form-view/form-view-text/form-view-text.component';
import { FormViewText2Component } from '../dynamic-forms/form-view/form-view-text2/form-view-text2.component';
import { FormViewComponent } from '../dynamic-forms/form-view/form-view.component';
import { ToolBarComponent } from '../dynamic-forms/tool-bar/tool-bar.component';
import { CopyFormConfigurationComponent } from '../forms/formview/copy-form-configuration/copy-form-configuration.component';
import { EditFormMultiTableComponent } from '../forms/formview/edit-form-multi-table/edit-form-multi-table.component';
import { EditFormComponent } from '../forms/formview/editform.component';
import { FormFieldPropertiesDetailActionsParamsComponent } from '../forms/formview/form-field-properties/form-field-properties-detail-actions-params/form-field-properties-detail-actions-params.component';
import { FormFieldPropertiesDetailActionsComponent } from '../forms/formview/form-field-properties/form-field-properties-detail-actions/form-field-properties-detail-actions.component';
import { FormFieldPropertiesDetailComponent } from '../forms/formview/form-field-properties/form-field-properties-detail/form-field-properties-detail.component';
import { FormFieldPropertiesComponent } from '../forms/formview/form-field-properties/form-field-properties.component';
import { FormConfigurationTabSelectComponent } from '../forms/gridview/filterview/form-configuration/form-configuration-tab-select/form-configuration-tab-select.component';
import { FormConfigurationComponent } from '../forms/gridview/filterview/form-configuration/form-configuration.component';
import { PromptFilterViewComponent } from '../forms/prompt-filter-view/prompt-filter-view.component';
import { CustomActionParametersComponent } from '../forms/simple-datagrid/custom-action-parameters/custom-action-parameters.component';
import { GridConfigDialogComponent } from '../forms/simple-datagrid/grid-config-dialog/grid-config-dialog.component';
import { SimpleDatagridComponent } from '../forms/simple-datagrid/simple-datagrid.component';
import { SimpleDatatreeComponent } from '../forms/simple-datatree/simple-datatree.component';
import { ComponentFactoryComponent } from '../system-utils/component-factory/component-factory-view.component';
import { GenericDatagridComponent } from '../system-utils/generic-datagrid/generic-datagrid.component';
import { GridSelectorComponent } from '../system-utils/grid-selector/grid-selector.component';
import { MessageDialogComponent } from '../system-utils/message-dialog/message-dialog.component';
import { Capitalize } from '../system-utils/pipes/capitalize';
import { SearchDialogComponent } from '../system-utils/search-dialog/search-dialog.component';
import { SearchInputComponent } from '../system-utils/search-input/search-input.component';
import { NgModelChangeDebouncedDirective } from '../system-utils/utils/directives/ngModelChangeDebounced-directive';
import { OnlyAlphaDirective } from '../system-utils/utils/directives/only-alpha.directive';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { NgxEditorModule } from 'ngx-editor';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import { GridsterModule } from 'angular-gridster2';
import { AdminServices } from '../services/AdminServices';
import { ControlEDirective } from '../system-utils/utils/directives/controE-directive';
import { FileLoaderComponent } from '../system-utils/file-loader/file-loader.component';
import { FileLoaderServices } from '../services/FileLoader.services';
import { SearchOptionListComponent } from '../system-utils/search-option-list/search-option-list.component';
import { CustomPaginatorIntl, LanguageServices } from '../services/LanguageServices';
import { ThemeService } from '../services/theme.service';
import { TranslateFormComponent } from '../forms/translate-form/translate-form.component';
import { TranslateFormNewComponent } from '../forms/translate-form/translate-form-new/translate-form-new.component';
import { TranslateFormAiComponent } from '../forms/translate-form/translate-form-ai/translate-form-ai.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgxColorsModule } from 'ngx-colors';
import {ScrollingModule} from '@angular/cdk/scrolling';
import { JsonViewerComponent } from '../system-utils/json-viewer/json-viewer.component';
import { DynamicLoaderService } from '../services/dynamic-loader.service';
import { CodeEditorComponent } from '../system-utils/code-editor/code-editor.component';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzSplitterModule } from 'ng-zorro-antd/splitter';
import { SafePipe } from '../system-utils/pipes/safe';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzFloatButtonModule } from 'ng-zorro-antd/float-button';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { GenericLogComponent, GridButtonRendererComponent } from '../forms/generic-log/generic-log.component';
import { GenericLogSearchPipe } from '../forms/generic-log/generic-log-search.pipe';
import { TranslateTA } from '../system-utils/pipes/translateTA';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzTreeModule } from 'ng-zorro-antd/tree';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { SearchInputNewComponent } from '../system-utils/search-input-new/search-input-new.component';
import { QuillModule } from 'ngx-quill'

ModuleRegistry.registerModules([
  CsvExportModule,
  ClientSideRowModelModule
]);

const maskConfig: Partial<IConfig> = {
    validation: false,
  };


@NgModule({
  declarations: [
    ActionsButtonsComponent,
    SidePanelComponent,
    ControlEDirective,
    CustomLoadingOverlay,
    QueryExecutorPopupDialog,
    QueryExecutorComponent,
    ArrayFilter,
    GenericIconComponent,
    ExpansePanelComponent,
    FormArrayComponentComponent,
    SuspendedMenuComponent,
    DragDirective,
    SidePanelStepperComponent,
    SidePanelStepComponent,
    QueryExecutorComponentSettings,
    FormItemComponentComponent,
    FormViewDirective, 
    CustomMaskDirective,
    UpperDirective,
    TooltipDirective,
    NumericDirective, 
    FormViewInputComponent, 
    DynamicFormsComponent, 
    GridSelectorComponent, 
    FormViewComponent, 
    ToolBarComponent, 
    FormViewSelectComponent, 
    FormViewDateComponent,
    FormViewTextComponent, 
    FormViewText2Component, 
    FormViewNumberComponent, 
    MessageDialogComponent, 
    FormViewSearchComponent,  
    GenericDatagridComponent, 
    Capitalize, 
    FormViewImageComponent,
    SearchDialogComponent,
    FormViewRichTextComponent,
    FormFieldPropertiesComponent, 
    FormFieldPropertiesDetailComponent, 
    FormFieldPropertiesDetailActionsComponent, 
    NgModelChangeDebouncedDirective,
    FormFieldPropertiesDetailActionsParamsComponent,
    CustomActionParametersComponent,
    OnlyAlphaDirective,
    PromptFilterViewComponent,
    SearchInputComponent,
    EditFormComponent,
    SimpleDatagridComponent,
    ComponentFactoryComponent,
    GridConfigDialogComponent,
    SimpleDatatreeComponent,
    FormConfigurationComponent,
    FormConfigurationTabSelectComponent,
    CopyFormConfigurationComponent,
    EditFormMultiTableComponent,
    FileLoaderComponent,
    SearchOptionListComponent,
    TranslateFormComponent,
    TranslateFormNewComponent,
    TranslateFormAiComponent,
    JsonViewerComponent,
    CodeEditorComponent,
    SafePipe,
    GenericLogComponent,
    GenericLogSearchPipe,
    GridButtonRendererComponent,
    TranslateTA,
    SearchInputNewComponent
  ],
  imports: [
    // O BrowserAnimationsModule NAO entra em modulo de funcionalidade: ele importa
    // o BrowserModule por dentro, e cai no mesmo NG05100 quando um componente
    // standalone que importe este modulo instancia os providers num injetor
    // proprio. As animacoes ja sao providas uma vez pelo AppModule.
    // O BrowserModule NAO entra aqui — modulo de funcionalidade importa o
    // CommonModule, que ja esta na lista abaixo. O construtor do BrowserModule
    // tem guarda e lanca NG05100 na segunda construcao, e um componente
    // STANDALONE que importa um NgModule ganha um injetor proprio: os providers
    // do modulo importado sao instanciados ali, de novo. Era o que estourava ao
    // desenhar um campo no construtor novo — WebhookFieldRenderer (standalone)
    // -> WebhookCreatorModule -> SharedModule -> BrowserModule.
    // Nada muda para quem consome: este modulo nunca EXPORTOU o BrowserModule,
    // e as diretivas comuns vem do CommonModule de qualquer jeito.
    AgGridModule,
    GridsterModule,
    CommonModule,
    DragDropModule,
    AngularSplitModule,
    ReactiveFormsModule,
    FormsModule,
    CdkStepperModule,
    TranslateModule,
    NzModalModule,
    NgxDatatableModule,
    DragDropModule,
    ClipboardModule,
    TreeviewModule.forRoot(),
    AngularSplitModule,
    FontAwesomeModule,
    ScrollingModule,
    QuillModule,
    NgxEditorModule.forRoot({
                locals: {
                    bold: 'Negrito',
                    italic: 'Itálico',
                    code: 'Código',
                    blockquote: 'Comentário',
                    underline: 'Sublinhado',
                    strike: 'Tachado',
                    bullet_list: 'Marcadores',
                    ordered_list: 'Numeração',
                    heading: 'Cabeçalho',
                    h1: 'Cabeçalho 1',
                    h2: 'Cabeçalho 2',
                    h3: 'Cabeçalho 3',
                    h4: 'Cabeçalho 4',
                    h5: 'Cabeçalho 5',
                    h6: 'Cabeçalho 6',
                    align_left: 'Alinhar à Esquerda',
                    align_center: 'Centralizar',
                    align_right: 'Alinhar à Direita',
                    align_justify: 'Justificar',
                    text_color: 'Cor da Fonte',
                    background_color: 'Cor do Fundo',
                    url: 'URL',
                    text: 'Texto',
                    insert: 'Inserir',
                    altText: 'Alt Texto',
                    title: 'Título',
                    remove: 'Remover',
                    insertLink: 'Inserir Link',
                    removeLink: 'Remover Link',
                    insertImage: 'Inserir Imagem'
                  
                }}),
        NgxMaskModule.forRoot(maskConfig),
        NgxColorsModule,
        NzButtonModule,
        NzIconModule,
        NzTooltipModule,
        NzDividerModule,
        NzSplitterModule,
        NzCardModule,
        NzSelectModule,
        NzInputModule,
        NzGridModule,
        NzTableModule,
        NzSwitchModule,
        NzDrawerModule,
        NzFloatButtonModule,
        NzDropDownModule,
        NzTooltipModule,
        NzDividerModule,
        NzPopoverModule,
        NzUploadModule,
        NzMenuModule,
        NzSpinModule,
        NzTabsModule,
        NzStepsModule,
        NzRadioModule,
        NzCollapseModule,
        NzCheckboxModule,
        NzTreeModule,
        NzDatePickerModule,
        NzProgressModule,
        NzAutocompleteModule,
        NzToolTipModule,
  ],

  schemas: [],
  providers:[
      IconServices,
      FileLoaderServices,
      SearchFieldService,
      TranslateService, 
      TranslateStore,
      AdminServices,
      LanguageServices,
      ThemeService,
      DynamicLoaderService,
      

  ],
  exports:[
    SearchInputNewComponent,
    ActionsButtonsComponent,
    SidePanelComponent,
    QueryExecutorComponent,
    CustomLoadingOverlay,
    ArrayFilter,
    ControlEDirective,
    GenericIconComponent,
    ExpansePanelComponent,
    FormArrayComponentComponent,
    SuspendedMenuComponent,
    TranslateModule,
    DragDirective,
    SidePanelStepperComponent,
    SidePanelStepComponent,
    QueryExecutorPopupDialog,
    QueryExecutorComponentSettings,
    FormItemComponentComponent,
    FormViewDirective, 
    CustomMaskDirective,
    UpperDirective,
    TooltipDirective,
    NumericDirective, 
    FormViewInputComponent, 
    DynamicFormsComponent, 
    GridSelectorComponent, 
    FormViewComponent, 
    ToolBarComponent, 
    FormViewSelectComponent, 
    FormViewDateComponent,
    FormViewTextComponent, 
    FormViewText2Component, 
    FormViewNumberComponent, 
    MessageDialogComponent, 
    FormViewSearchComponent,  
    GenericDatagridComponent, 
    Capitalize, 
    FormViewImageComponent,
    SearchDialogComponent,
    FormViewRichTextComponent,
    FormFieldPropertiesComponent, 
    FormFieldPropertiesDetailComponent, 
    FormFieldPropertiesDetailActionsComponent, 
    NgModelChangeDebouncedDirective,
    FormFieldPropertiesDetailActionsParamsComponent,
    CustomActionParametersComponent,
    OnlyAlphaDirective,
    PromptFilterViewComponent,
    SearchInputComponent,
    EditFormComponent,
    SimpleDatagridComponent,
    ComponentFactoryComponent,
    GridConfigDialogComponent,
    SimpleDatatreeComponent,
    FormConfigurationComponent,
    FormConfigurationTabSelectComponent,
    CopyFormConfigurationComponent,
    EditFormMultiTableComponent,
    SearchOptionListComponent,
    TranslateFormComponent,
    JsonViewerComponent,
    QueryExecutorComponent,
    SafePipe,
    CodeEditorComponent,
    GenericLogComponent,
    GenericLogSearchPipe,
    GridButtonRendererComponent,
    NzButtonModule,
    NzIconModule,
    NzTooltipModule,
    NzDividerModule,
    NzSplitterModule,
    NzCardModule,
    NzSelectModule,
    NzInputModule,
    NzGridModule,
    NzTableModule,
    NzSwitchModule,
    NzDrawerModule,
    NzFloatButtonModule,
    NzDropDownModule,
    NzTooltipModule,
    NzDividerModule,
    NzPopoverModule,
    TranslateTA,
    NzUploadModule,
    NzMenuModule,
    NzSpinModule,
    NzTabsModule,
    NzStepsModule,
    NzRadioModule,
    NzCollapseModule,
    NzCheckboxModule,
    NzTreeModule,
    NzDatePickerModule,
    NzProgressModule,
    NzAutocompleteModule,
    NzToolTipModule,
    QuillModule
   ]
})
export class SharedModule { }
